import React from 'react';
import PropTypes from 'prop-types';
import { toLower, includes } from 'lodash';
import { StyledQuality } from './styled';
import { LOW_QUALITY, GOOD_QUALITY, HIGH_QUALITY } from './constants';
import useAlertLevelConfigs from '../../../../common/hooks/useAlertLevelConfig';

/**
 * Feedback
 * @param type {string}
 * @returns {JSX.Element}
 */
const Feedback = ({ type = 'Low Quality', alertLevels }) => {
  const { getLevelColor } = useAlertLevelConfigs(alertLevels);
  const feedbackType = toLower(type);

  return (
    <>
      {includes(['low quality', 'low'], feedbackType) && (
        <StyledQuality style={{ background: getLevelColor('Low') }}>
          {LOW_QUALITY}
        </StyledQuality>
      )}
      {includes(['good quality', 'good'], feedbackType) && (
        <StyledQuality style={{ background: getLevelColor('Good') }}>
          {GOOD_QUALITY}
        </StyledQuality>
      )}
      {includes(['high quality', 'high'], feedbackType) && (
        <StyledQuality style={{ background: getLevelColor('High') }}>
          {HIGH_QUALITY}
        </StyledQuality>
      )}
      {feedbackType === '-' && <>{feedbackType}</>}
    </>
  );
};

Feedback.propTypes = {
  type: PropTypes.string,
  alertLevels: PropTypes.array
};

export default Feedback;
